export default __webpack_public_path__ + "static/media/survey-orb.df02c25e.svg";